import { SettingsAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  TUpdateGeneralSettingsDTO,
  IUpdateGeneralSettingsResponse,
  TGetGeneralSettingsResponse,
} from '@/models/settings.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SETTINGS_SLICE_NAME } from './models';

export const getGeneralSettings = createAsyncThunk<
  TGetGeneralSettingsResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${SETTINGS_SLICE_NAME}/getGeneralSettings`,
  async () => {
    const response = await SettingsAPI.getGeneralSettings();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateGeneralSettings = createAsyncThunk<
  IUpdateGeneralSettingsResponse,
  TUpdateGeneralSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SETTINGS_SLICE_NAME}/updateGeneralSettings`,
  async (data) => {
    const response = await SettingsAPI.updateGeneralSettings(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
